<template>
  <div class="configuration-help-tab w-100">
    <div class="ap-title ap-title__main px-3 pt-3 pb-2">
      <span>{{ $t('global.config') }}</span>
    </div>
    <div class="px-3">
      <shortcuts-and-voice-commands-table :table-data="configurationShortcuts" />
    </div>
  </div>
</template>

<script>
import ShortcutsAndVoiceCommandsTable from '@/components/help/shortcutsAndVoiceCommands/ShortcutsAndVoiceCommandsTable'

export default {
    name: 'ConfigurationHelpTab',
    components: {
        ShortcutsAndVoiceCommandsTable
    },
    data() {
        return {
            configurationShortcuts: [
                {
                    tableTitle: this.$t('component.shortcutsModal.labels.title.configurationTitle'),
                    tableElements: [
                        {
                            action: this.$t('component.shortcutsModal.labels.action.addConfigurationElement'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-level-down', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.addConfigurationElement')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.updateConfigurationElement'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'E' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.updateConfigurationElement')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.deleteConfigurationElement'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: this.$t('component.shortcutsModal.delKey') }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.deleteConfigurationElement')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.codificationsSearcher'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'F' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.codificationsSearcher')
                        }
                    ]
                }
            ]
        }
    }
}
</script>
